module.exports = __webpack_public_path__ + "img/bg-s.1ef42b6b.jpg";